__turbopack_context__.v({
  "liveblogTimeline": "LiveblogTimeline-module-scss-module__mg25Cq__liveblogTimeline",
  "liveblogTimeline__loader": "LiveblogTimeline-module-scss-module__mg25Cq__liveblogTimeline__loader",
  "liveblogTimeline__updates": "LiveblogTimeline-module-scss-module__mg25Cq__liveblogTimeline__updates",
  "noMoreContent": "LiveblogTimeline-module-scss-module__mg25Cq__noMoreContent",
});
